import { Pipe, PipeTransform } from '@angular/core';
import { CommonUtilty } from '../../../core/utilities/commonUtility'

@Pipe({
  name: 'MMSClientData'
})
export class MMSClientDataPipe implements PipeTransform {

  constructor(private commonUtilty: CommonUtilty) { }

  public transform(value: any, args?: any, argValue?: any): any {
    if (value) {

      switch (args) {
        case "firstName":
          return this.commonUtilty.getFirstNameFromClient(value)
          break;
        case "lastName":
          return this.commonUtilty.getLastNameFromClient(value)
          break;
        case "fullName":
          return (this.commonUtilty.getFirstNameFromClient(value) || '') + " " + (this.commonUtilty.getLastNameFromClient(value) || '')
          break;
        case "preferredContact":
          return this.commonUtilty.getPrefferedContactFromClient(value)
          break;
        case "preferredEmail":
          return this.commonUtilty.getPrefferedEmailFromClient(value)
          break;
        case "dateOfBirth":
          return this.commonUtilty.getDateOfBirthFromClient(value)
          break;
        case "genderCd":
        case "gender":
          return this.commonUtilty.getGenderFromClient(value)
          break;
        case "occupationCd":
        case "Occupation":
        case "firstOccupation":
          return this.commonUtilty.getFirstOccupationCd(value)
          break;
        case "countryOfBirth":
        case "countryOfBirthCd":
          return this.commonUtilty.getCountryOfBirthFromClient(value)
          break;
        case "citizenshipCd":
        case "citizenship":
          return this.commonUtilty.getCitizenshipFromClient(value)
          break;
        case "personIdentityList":
        case "personIdentities":
          return this.commonUtilty.getPersonIdentityListFromClient(value)
          break;
        case "clientAddressList":
        case "AddressList":
        case "Addresses":
          return this.commonUtilty.getAddressListFromClient(value)
          break;
        case "workqueue":
          return argValue && Array.isArray(value) ? value.filter(val => val.workQueue == argValue) : value
          break;
        default:
          return "-"
          break;
      }

    }
    return null;
  }



}
